import request from '@/request';

// ==================== Mock 数据（后端未就绪时使用） ====================
const USE_MOCK = false;

const mockVersions = [
  {
    id: 'v1',
    version: '2.9.0',
    releaseDate: '2026-08-20T00:00:00',
    publishTime: '2026-08-01T10:00:00', // 设为过期时间，让 3.0.0 成为当前版本
    status: 'PUBLISHED',
    legacy: true, // 历史遗留数据：编辑页不展示，仅参与版本号去重
    popupExpiryDays: 14,
    features: [
      {
        id: 'f1',
        title: 'Cost Dashboard Upgrade',
        titleZh: '费用看板全新升级',
        description: 'Supports multi-dimensional cost analysis, with new application cost trend charts and service cost rankings to help teams better manage cloud resource spending.',
        descriptionZh: '支持多维度成本分析，新增应用成本趋势图和服务成本排名，帮助团队更好地管控云资源开支。',
        images: [
          'https://placehold.co/600x600/4f46e5/ffffff?text=Cost+Dashboard+1',
          'https://placehold.co/600x600/4338ca/ffffff?text=Cost+Dashboard+2'
        ],
        roles: 'Admin, Finance',
        menuPath: 'Finance > Cost Explorer',
        sortOrder: 0
      },
      {
        id: 'f2',
        title: 'Notification Subscription Management',
        titleZh: '通知订阅管理',
        description: 'Brand new notification subscription settings, supporting user/group subscriptions and channel subscriptions, with flexible configuration for DingTalk, WeCom and other notification channels.',
        descriptionZh: '全新的通知订阅设置，支持用户/群组订阅和渠道订阅，可灵活配置钉钉、企业微信等通知渠道。',
        images: [
          'https://placehold.co/600x600/0ea5e9/ffffff?text=Notification+1',
          'https://placehold.co/600x600/0284c7/ffffff?text=Notification+2',
          'https://placehold.co/600x600/0369a1/ffffff?text=Notification+3'
        ],
        roles: 'Admin',
        menuPath: 'Administration > Notification Management',
        sortOrder: 1
      },
      {
        id: 'f3',
        title: 'Audit Log Enhancement',
        titleZh: '审计日志增强',
        description: 'Audit logs now include operation type filtering and username search, supporting more precise operation tracing.',
        descriptionZh: '审计日志新增操作类型筛选、用户名搜索，支持更精确的操作追溯。',
        images: [
          'https://placehold.co/600x600/10b981/ffffff?text=Audit+Log'
        ],
        roles: 'All',
        menuPath: 'Audit',
        sortOrder: 2
      }
    ]
  },
  {
    id: 'v2',
    version: '2.8.0',
    releaseDate: '2026-07-15T00:00:00',
    publishTime: '2026-07-16T09:00:00',
    status: 'PUBLISHED',
    legacy: true, // 历史遗留数据：编辑页不展示，仅参与版本号去重
    popupExpiryDays: 14,
    features: [
      {
        id: 'f4',
        title: 'Application Detail Page Redesign',
        titleZh: '应用详情页重构',
        description: 'Newly designed application detail page, integrating health checks, resource quotas, deployment configuration and other information in a one-stop view.',
        descriptionZh: '全新设计的应用详情页，集成健康检查、资源配额、部署配置等信息的一站式视图。',
        images: [
          'https://placehold.co/600x600/8b5cf6/ffffff?text=App+Detail+1',
          'https://placehold.co/600x600/7c3aed/ffffff?text=App+Detail+2'
        ],
        roles: 'All',
        menuPath: 'Dashboard > Overview',
        sortOrder: 0
      },
      {
        id: 'f5',
        title: 'Log Center Optimization',
        titleZh: '日志中心优化',
        description: 'Log query performance improved, supporting more flexible time range filtering and keyword search.',
        descriptionZh: '日志查询性能提升，支持更灵活的时间范围筛选和关键词搜索。',
        images: [],
        roles: 'All',
        menuPath: 'Monitor > Log Center',
        sortOrder: 1
      }
    ]
  },
  {
    id: 'v3',
    version: '3.0.0',
    releaseDate: '2026-08-21T00:00:00',
    publishTime: new Date().toISOString(), // 使用当前时间，确保弹窗能显示
    status: 'PUBLISHED',
    popupExpiryDays: 14,
    features: [
      {
        id: 'f6',
        title: 'AI Ops Assistant',
        titleZh: 'AI 运维助手',
        description: 'Introducing our revolutionary AI-powered operations assistant that transforms how teams manage cloud infrastructure. This intelligent system leverages advanced machine learning algorithms to provide natural language query capabilities, allowing operators to ask complex questions about system health, resource utilization, and performance metrics in plain English. The assistant can automatically analyze alert patterns, identify root causes of incidents, and suggest remediation actions based on historical data and best practices. It integrates seamlessly with existing monitoring tools and supports multiple notification channels including Slack, Microsoft Teams, and email. The AI model is continuously trained on operational data to improve accuracy and provide increasingly relevant recommendations. Key features include automated incident correlation, predictive anomaly detection, intelligent alert grouping to reduce noise, and comprehensive reporting dashboards. Teams can customize the assistant behavior through configuration profiles, set up automated workflows for common scenarios, and track resolution metrics over time. The system supports multi-tenant deployments with role-based access control, ensuring data isolation and security compliance. Performance optimizations enable sub-second response times even for complex analytical queries across large datasets.',
        descriptionZh: '我们推出了革命性的 AI 智能运维助手，彻底改变了团队管理云基础设施的方式。该智能系统采用先进的机器学习算法，提供自然语言查询功能，允许运维人员用普通英语询问有关系统健康状态、资源利用率和性能指标的复杂问题。助手能够自动分析告警模式、识别事件根本原因，并基于历史数据和最佳实践建议修复措施。它与现有监控工具无缝集成，支持 Slack、Microsoft Teams 和电子邮件等多个通知渠道。AI 模型在运维数据上持续训练，以提高准确性并提供越来越相关的建议。主要功能包括自动事件关联、预测性异常检测、智能告警分组以减少噪音，以及全面的报告仪表板。团队可以通过配置配置文件自定义助手行为，为常见场景设置自动化工作流，并随时间跟踪解决指标。系统支持多租户部署和基于角色的访问控制，确保数据隔离和安全合规。性能优化使其即使对跨大型数据集的复杂分析查询也能实现亚秒级响应时间。',
        images: [
          'https://placehold.co/600x600/ec4899/ffffff?text=AI-powered operations assistant'
        ],
        roles: 'Admin',
        menuPath: 'Experimental > AI Ops',
        sortOrder: 0
      },
      {
        id: 'f7',
        title: 'Release Notes Management',
        titleZh: 'Release Notes 管理',
        description: 'Brand new version release notes management feature, supporting creation, editing, and publishing of version update logs.',
        descriptionZh: '全新的版本发布说明管理功能，支持创建、编辑、发布版本更新日志。',
        images: [],
        roles: 'Admin',
        menuPath: 'Administration > Release Notes',
        sortOrder: 1
      }
    ]
  }
];

let mockData = [...mockVersions];

// Mock 辅助函数
function mockDelay(data, ms = 300) {
  return new Promise((resolve) => setTimeout(() => resolve(data), ms));
}
// Mock 模式模拟后端 ResponseResult 包装格式
function mockSuccess(data) {
  return { code: 200, msg: 'success', data };
}

// ==================== API 函数 ====================

/**
 * 获取当前生效的 Release Note（用户端）
 * 仅返回 status=PUBLISHED 且未过期的版本
 * 返回值含 dismissed 字段，无需单独调用 isDismissed
 */
export function getCurrentReleaseNote() {
  if (USE_MOCK) {
    const now = new Date();
    const published = mockData.find((v) => {
      if (v.status !== 'PUBLISHED') return false;
      if (v.publishTime && v.popupExpiryDays) {
        const expiry = new Date(v.publishTime);
        expiry.setDate(expiry.getDate() + v.popupExpiryDays);
        return now <= expiry;
      }
      return false;
    });
    // Mock: dismissed 默认为 false（未关闭）
    return mockDelay(mockSuccess(published ? { ...published, dismissed: false } : null));
  }
  return request.get('/release-notes/current');
}

/**
 * 获取所有版本列表（管理端，含 DRAFT）
 * 权限：ADMIN_CONSOLE
 */
export function getAllVersions() {
  if (USE_MOCK) {
    return mockDelay(mockSuccess([...mockData].sort((a, b) => new Date(b.releaseDate) - new Date(a.releaseDate))));
  }
  return request.get('/release-notes/versions');
}

/**
 * 获取已发布版本列表（公开，changeLog 页面用）
 * 权限：所有登录用户
 * 仅返回 status=PUBLISHED 的版本，按 publishTime DESC 排序
 */
export function getPublishedVersions() {
  if (USE_MOCK) {
    return mockDelay(mockSuccess(
      [...mockData]
        .filter((v) => v.status === 'PUBLISHED')
        .sort((a, b) => new Date(b.releaseDate) - new Date(a.releaseDate))
    ));
  }
  return request.get('/release-notes/published');
}

/**
 * 保存草稿（创建/更新，status 保持 DRAFT）
 */
export function saveVersion(params) {
  if (USE_MOCK) {
    return mockDelay(null, 200).then(() => {
      if (params.id) {
        const idx = mockData.findIndex((v) => v.id === params.id);
        if (idx !== -1) {
          if (mockData[idx].status === 'PUBLISHED') {
            throw new Error('Cannot edit published version');
          }
          mockData[idx] = {
            ...mockData[idx],
            version: params.version,
            releaseDate: params.releaseDate,
            popupExpiryDays: params.popupExpiryDays,
            features: (params.features || []).map((f, i) => ({
              ...f,
              id: f.id || `f_mock_${Date.now()}_${i}`,
              sortOrder: f.sortOrder ?? i
            }))
          };
          return mockSuccess(mockData[idx]);
        }
        return mockSuccess(null);
      }
      const newVersion = {
        id: `v_${Date.now()}`,
        version: params.version,
        releaseDate: params.releaseDate,
        publishTime: null,
        status: 'DRAFT',
        popupExpiryDays: params.popupExpiryDays ?? 14,
        features: (params.features || []).map((f, i) => ({
          ...f,
          id: f.id || `f_mock_${Date.now()}_${i}`,
          sortOrder: f.sortOrder ?? i
        }))
      };
      mockData.push(newVersion);
      return mockSuccess(newVersion);
    });
  }
  return request.post('/release-notes/version', params);
}

/**
 * 发布版本（DRAFT → PUBLISHED，记录 publishTime）
 */
export function publishVersion(id) {
  if (USE_MOCK) {
    return mockDelay(mockSuccess(null), 200).then((res) => {
      const v = mockData.find((item) => item.id === id);
      if (!v) throw new Error('Version not found');
      if (v.status !== 'DRAFT') throw new Error('Only draft can be published');
      v.status = 'PUBLISHED';
      v.publishTime = new Date().toISOString();
    });
  }
  return request.post('/release-notes/version/publish', { id });
}

/**
 * 删除版本（软删除）
 */
export function deleteVersion(id) {
  if (USE_MOCK) {
    return mockDelay(mockSuccess(null), 200).then((res) => {
      mockData = mockData.filter((v) => v.id !== id);
    });
  }
  return request.delete(`/release-notes/version/${id}`);
}

/**
 * 记录用户已关闭弹窗
 */
export function dismissReleaseNote(params) {
  if (USE_MOCK) return mockDelay(mockSuccess(null), 100);
  return request.post('/release-notes/dismiss', params);
}

/**
 * 上传文件到 S3
 * @returns {Promise<{rawUrl: string, presignedUrl: string}>}
 */
export async function uploadFile(file, folder = 'release-notes') {
  if (USE_MOCK) {
    const url = URL.createObjectURL(file);
    return mockDelay({ rawUrl: url, presignedUrl: url }, 500);
  }
  const formData = new FormData();
  formData.append('file', file);
  formData.append('folder', folder);
  const res = await request.post('/file/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res.data;
}

/**
 * 删除 S3 文件——仅在保存失败时回滚清理"本次刚上传、尚未入库"的图片（见 index.jsx handleSaveDraft 的 catch）。
 * 已入库图片的删除由后端 saveVersion/deleteVersion 按 DB 差异自动清理，正常的图片删除流程不要调此接口。
 * @param {string} fileUrl - 原始 S3 URL（rawUrl，非预签名 URL）
 */
export async function deleteFile(fileUrl) {
  if (USE_MOCK) return mockDelay(mockSuccess(null), 100);
  return request.delete('/file/delete', { params: { fileUrl } });
}
